import script from "./Confirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=ts"

import "./Confirmation.vue?vue&type=style&index=0&id=c40f3b74&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c40f3b74"]])

export default __exports__